module.exports = __webpack_public_path__ + "img/venue-image.4b54377e.png";